import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  static properties = {
    notification: {
      type: String,
    },
    productId: {
      type: String,
    },
    product: {
      type: String
    }
  }

  constructor() {
    super()

    this.onSubmitHandler = this.onSubmitHandler.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.submitButton = this.querySelector('[type="submit"]')

    this.form?.addEventListener('submit', this.onSubmitHandler)

    if (!!!this.closest('.card')) {
      this.receiver = broadcastReceiver('quantity', (...args) => {
        this.getQuantityFromDocument(...args)
      })
    }

    window.addEventListener('reachedMaxQuantity', this.onReachedMaxQuantity.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.form?.removeEventListener('submit', this.onSubmitHandler)

    this.receiver?.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1

      this.toggleErrorMessage(!!data.max && data.value > data.max)
    }
  }

  onReachedMaxQuantity(e) {
    if (e.detail.product === this.product) this.toggleErrorMessage(true)
  }

  toggleErrorMessage(showMessage = true) {
    this.closest('.js-product')?.querySelectorAll('.js-quantity-error')
      .forEach(error => error.querySelector('.product-form__error-message--text').innerHTML = showMessage ? error.dataset.message : '')
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    this.submitButton.setAttribute('disabled', true)
    this.submitButton.classList.add('loading')
    const notificationId = `cart-notification-product-${this.dataset.itemid}`

    // count how many items of the variant added are already in cart
    let qtyAdded = 0;
    let itemsRes = await fetch('/cart.js')
    let itemsJson = await itemsRes.json()

    itemsJson.items.forEach(item => qtyAdded += (item.id == Number(this.dataset.itemid)) ? item.quantity : 0)

    if (!!this.dataset.maxqty && qtyAdded >= Number(this.dataset.maxqty)) {

      this.submitButton.removeAttribute('disabled')
      this.submitButton.classList.remove('loading')

      this.updateErrorMessage(`Limit ${this.dataset.maxqty} per order`)

      this.dispatchEvent(
        new CustomEvent('productAddFailed', {
          bubbles: true,
          composed: true,
          detail: {
            id: `cart-notification-product-error-${this.productId}`,
            productId: this.productId,
            itemId: this.dataset.itemid,
            sellingPlanId: this.dataset.sellingplanid || ''
          },
        })
      )

      return;
    }

    const response = await addToCart(JSON.parse(serializeForm(this.form)))

    if (response.errors) {
      this.submitButton.removeAttribute('disabled')
      this.submitButton.classList.remove('loading')

      this.updateErrorMessage(response.errors);

      this.dispatchEvent(
        new CustomEvent('productAddFailed', {
          bubbles: true,
          composed: true,
          detail: {
            id: `cart-notification-product-error-${this.productId}`,
            productId: this.productId,
            itemId: this.dataset.itemid,
            sellingPlanId: this.dataset.sellingplanid || ''
          },
        })
      )

      return;
    }

    reRenderShopifySections(
      response
    )

    setTimeout(
      () => document.querySelector('hh-mini-cart')?.calculateHeight(),
      150
    )

    this.dispatchEvent(
      new CustomEvent('productAdded', {
        bubbles: true,
        composed: true,
        detail: {
          id: notificationId,
          productId: this.productId,
          itemId: this.dataset.itemid,
          sellingPlanId: this.dataset.sellingplanid || ''
        },
      })
    )

    this.updateErrorMessage('');

    this.submitButton.removeAttribute('disabled')
    this.submitButton.classList.remove('loading')
  }

  updateErrorMessage(message) {
    this.closest('.js-product')?.querySelectorAll('.product-form__error-message--text')
      .forEach(errMsg => errMsg.innerHTML = message)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
